import React, { FC } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { INavigationItemProps } from "../types";
import Icon from "../../Icon";

export const NavigationItem: FC<INavigationItemProps> = (props) => {
  const { t } = useTranslation();
  const { data, topDivider, bottomDivider } = props;
  const content = (
    <>
      {data.icon ? <Icon className="navigation__icon">{data.icon}</Icon> : null}
      {t(data.label)}
    </>
  );

  return (
    <div>
      {topDivider ? <div className="navigation__divider" /> : null}
      {"onClick" in data ? (
        <button
          className="navigation__item navigation__button"
          type="button"
          onClick={data.onClick}
        >
          {content}
        </button>
      ) : (
        <NavLink
          key={data.label}
          className="navigation__item"
          to={data.link}
          activeClassName="navigation__item--selected"
        >
          {content}
        </NavLink>
      )}
      {bottomDivider ? <div className="navigation__divider" /> : null}
    </div>
  );
};

NavigationItem.defaultProps = {
  topDivider: true,
  bottomDivider: true,
};
